import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Backdrop,
  Button,
  CircularProgress,
  Container,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import { OrgAdminApi } from "../../api/OrgAdminApi";
import ReactSwal from "../../helper/AlertHelper";

export function confirmDeleteGrp(id, onDeleted) {
  ReactSwal.fire({
    title: "確定要刪除嗎？",
    icon: "warning",
    showConfirmButton: true,
    showCancelButton: true,
    confirmButtonText: "確定",
    cancelButtonText: "取消",
    cancelButtonColor: "#a7a7a7",
  }).then((result) => {
    if (!result.isConfirmed) {
      return;
    }

    OrgAdminApi.deleteGrpCallback(id, (isSuccess, msg) => {
      if (!isSuccess) {
        toast.error(typeof msg === "string" && msg ? msg : "刪除失敗");
        return;
      }

      toast.success("刪除成功");
      onDeleted();
    });
  });
}

export default function UserGrpListPage() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const loadList = useCallback(() => {
    setIsLoading(true);
    OrgAdminApi.getMyGrpListCallback((isSuccess, msg, data) => {
      if (!isSuccess) {
        toast.error(typeof msg === "string" && msg ? msg : "讀取社別失敗");
        setRows([]);
        setIsLoading(false);
        return;
      }

      setRows(Array.isArray(data) ? data : []);
      setIsLoading(false);
    });
  }, []);

  useEffect(() => {
    loadList();
  }, [loadList]);

  return (
    <Container maxWidth="lg">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mt: 2, mb: 3 }}
      >
        <Typography variant="h4">社別管理</Typography>
        <Button
          variant="contained"
          endIcon={<AddIcon />}
          onClick={() => navigate("/user/grp/create")}
        >
          新增社
        </Button>
      </Stack>

      <Paper sx={{ px: 3, pb: 3 }} elevation={3}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center">次序</TableCell>
                <TableCell align="center">社代碼</TableCell>
                <TableCell align="center">中文名稱</TableCell>
                <TableCell align="center">English Name</TableCell>
                <TableCell align="center">動作</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!isLoading && rows.length === 0 ? (
                <TableRow>
                  <TableCell align="center" colSpan={5}>
                    未有社別
                  </TableCell>
                </TableRow>
              ) : (
                rows.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell align="center">{row.display_pos}</TableCell>
                    <TableCell align="center">{row.grp_code || "-"}</TableCell>
                    <TableCell align="center">{row.name_zh || "-"}</TableCell>
                    <TableCell align="center">{row.name_en || "-"}</TableCell>
                    <TableCell align="center">
                      <Stack direction="row" spacing={1} justifyContent="center">
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() => navigate(`/user/grp/${row.id}`)}
                        >
                          編輯
                        </Button>
                        <Button
                          size="small"
                          variant="outlined"
                          color="error"
                          onClick={() => confirmDeleteGrp(row.id, loadList)}
                        >
                          刪除
                        </Button>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Container>
  );
}
